export function getFormattedDateTime() {
  const now = new Date();

  const options = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true, // 12-hour format
  };

  const formattedDate = now.toLocaleString("en-US", options);

  return formattedDate;
}

export function RandomOrderId() {
  return "AP" + (Math.floor(Math.random() * (9999 - 1001 + 1)) + 1001);
}
